type TRouteGroup = {
  Index: string;
  [key: string]: string;
};

const RelativeRoutes = {
  Obrat: {
    Index: "/obraty",
    GetFiltered: "/get-filtered",
    GetFilteredGroups: "/get-filtered-groups",
    Edit: "/edit",
    Create: "/create",
    Delete: "/delete",
    Export: "/export",
  },
  CenovaPonuka: {
    Index: "/cenove-ponuky",
    Edit: "/edit",
    EditState: "/edit-state",
    New: "/new",
    Create: "/create",
    Delete: "/delete",
    CreateCopy: "/create-copy",
    GetNew: "/get-new",
    GetFiltered: "/get-filtered",
    GetWithIndex: "/get-with-index",
    Export: "/export",
  },
  Cenik: {
    Index: "/cenik",
    GetFiltered: "/get-filtered",
    Refresh: "/refresh",
    GetLastRefreshDate: "/last-refresh-date",
  },
  CSSkupina: {
    Index: "/cs-skupiny",
    GetAll: "/get-all",
  },
  Kontakt: {
    Index: "/kontakty",
    GetFiltered: "/get-filtered",
    GetWithIndex: "/get-with-index",
    GetCitiesAndDistricts: "/get-cities-and-districts",
    GetById: "/get-by-id",
    GetObchodniciByKontaktIds: "/get-obchodnici-by-kontakt-ids",
    Edit: "/edit",
    Create: "/create",
    Delete: "/delete",
    GetLastId: "/get-last-id",
    AddBulk: "/add-bulk",
    Export: "/export",
  },
  User: {
    Index: "/user",
    Login: "/login",
    Auth: "/auth",
    FetchObchodnik: "/fetch-obchodnik",
    FetchObchodniciByArray: "/fetch-obchodnici-by-array",
    FetchObchodnici: "/fetch-obchodnici",
    EditUserInfo: "/edit-user-info",
    ChangePassword: "/change-password",
    UploadProfileImage: "/upload-profile-image",
    AdminEditUserInfo: "/admin-edit-user-info",
    AdminEditUserPermissions: "/admin-edit-user-permissions",
    AdminAddUser: "/admin-add-user",
    AdminChangePassword: "/admin-change-password",
    AdminRemoveUser: "/admin-remove-user",
  },
} as const;

export const asAbsolute = (
  group: { Index: string; [key: string]: string },
  route: string
) => {
  if (!Object.values(group).includes(route)) {
    throw new Error(`Route "${route}" does not exist in the provided group.`);
  }

  if (group.Index === route) {
    return `${group.Index}`;
  }

  return `${group.Index}${route}`;
};

export const getAbsoluteRoutes = (): typeof RelativeRoutes => {
  const absoluteRoutes: {
    [group: string]: TRouteGroup;
  } = {};

  for (const [groupName, groupRoutes] of Object.entries(RelativeRoutes)) {
    const groupAbsoluteRoutes: { [key: string]: string } = {};

    for (const [routeName, routePath] of Object.entries(groupRoutes)) {
      groupAbsoluteRoutes[routeName] = asAbsolute(groupRoutes, routePath);
    }

    absoluteRoutes[groupName] = groupAbsoluteRoutes as TRouteGroup;
  }

  return absoluteRoutes as typeof RelativeRoutes;
};

export const APIRoutes = getAbsoluteRoutes();
